const defaultState = {
	plantOptions: [],
	useYnOptions: [],
	//2022-07-21 snjung
	deptCdOptions: [],
	//2022-07-21 snjung
	employeeTypeOptions: [],
	searchParams: {
		plantCd: '',
		userId: null,
		userName: null,
		useYn: null,
		mpassYn: null
	},

	users: {
		currentPage: 1,
		pageUnit: null,
		totalSize: 0,
		data: []
	},

	// groups: {
	// 	currentPage: 1,
	// 	pageUnit: 5,
	// 	totalSize: 0
	// },
	selectedUsers: []
};

export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
